export default "__VITE_ASSET__BHt7rhpY__"